import React, { useEffect, useState } from "react";
import { useLang } from "@/contexts/LanguageContext";
import { COOKIE } from "@/lib/translations";

const STORAGE_KEY = "fd_cookie_consent";

const CookieBanner = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);
  const copy = COOKIE[lang] || COOKIE.nl;

  useEffect(() => {
    const t = setTimeout(() => {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-[440px] z-[60] bg-black text-white p-6 md:p-7 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.5)] border border-white/10"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="flex items-center gap-3 mb-3">
        <span className="w-8 h-[1px] bg-[#E11D2E]" />
        <p className="text-[10px] uppercase tracking-[0.28em] text-white/60">
          {copy.title}
        </p>
      </div>
      <p className="text-sm leading-relaxed text-white/80 mb-5">{copy.body}</p>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => decide("accepted")}
          className="px-5 py-2.5 bg-white text-black text-[11px] uppercase tracking-[0.22em] font-medium hover:bg-[#E11D2E] hover:text-white transition-colors"
          data-testid="cookie-accept"
        >
          {copy.accept}
        </button>
        <button
          type="button"
          onClick={() => decide("declined")}
          className="px-5 py-2.5 text-[11px] uppercase tracking-[0.22em] font-medium text-white/70 hover:text-white transition-colors"
          data-testid="cookie-decline"
        >
          {copy.decline}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
